// client/src/routes/_auth/confirm-deletion.$token.tsx — „Confirmarea ștergerii contului" · D-3004.
//
// The path is the server's, not this file's: `RequestAccountDeletionCommandHandler` composes
// `{origin}/confirm-deletion/{token}` with nothing after the token, and every deletion mail ever
// sent points at exactly that, so the spelling is fixed.
//
// Under the pathless `_auth` layout, the frame for a page opened from a mail. Nobody is redirected
// away from here: the link is usually opened in a browser that holds no session, and when one is
// held the confirmation still applies to the account the link names, whoever is signed in. The
// route bootstraps the session, as `/confirm-email-change/$token` does, so the page can offer
// „Continuați" to a visitor who holds one and re-read it once the deletion is scheduled.

import { createFileRoute } from '@tanstack/react-router';

import { ConfirmAccountDeletion } from '@/features/auth/ConfirmAccountDeletion';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/_auth/confirm-deletion/$token')({
  beforeLoad: async () => {
    await ensureSession();
  },
  component: ConfirmAccountDeletionScreen,
});

function ConfirmAccountDeletionScreen() {
  const { token } = Route.useParams();
  return <ConfirmAccountDeletion token={token} />;
}
